<template>
  <div class="mb-4 pb-4">
    <div class="d-flex align-center">
      <div>
        <v-btn @click="$router.push('main')" class="left-arrow" icon>
          <v-icon>mdi-arrow-top-left</v-icon>
        </v-btn>
      </div>
      <div class="ml-2">
        <span class="header"> News</span>
      </div>
    </div>
    <div v-if="!skeleton_loader">
      <v-skeleton-loader
        v-for="itm in 3"
        class="my-5"
        height="250"
        :key="itm"
        width="100%"
        type="card, list-item-three-line"
      ></v-skeleton-loader>
    </div>
    <v-card
      v-else
      v-for="itm in newsData"
      :key="itm.id"
      elevation="2"
      class="my-3 card-height"
      style="cursor: pointer"
    >
      <div class="d-flex">
        <div>
          <v-img
            class="image"
            width="15rem"
            height="13.25rem"
            :src="itm.image_url"
            :lazy-src="lazy_img"
          >
          </v-img>
        </div>
        <div class="d-flex flex-column">
          <v-card-text @click="goToNews(itm.news_url)" class="pb-0">
            <div class="news-title mb-3">
              {{ itm.title }}
            </div>
            <div v-if="!$vuetify.breakpoint.xsOnly" class="mt-7">
              <div class="news-subtitle">
                {{ itm.description.substring(0, 170) }}...
                <!-- <span>see more</span> -->
              </div>
            </div>
          </v-card-text>
          <v-card-text class="py-0">
            <div class="since" v-if="itm.all_growth.length">
              <div class="since-news mb-2 mr-2">Since News</div>
              <div @click="routeToSearchPage(itm.all_growth[0])" class="mx-2">
                <span class="brand-name mr-1">
                  {{ itm.all_growth[0].symbol }}
                </span>
                <span
                  v-if="itm.all_growth[0].growth != null"
                  :class="
                    itm.all_growth[0].growth < 0 ? 'red--text' : 'green--text'
                  "
                  class="p-age mr-1"
                >
                  {{ itm.all_growth[0].growth >= 0 ? "+" : ""
                  }}{{ itm.all_growth[0].growth }} %
                </span>
                <v-icon small :x-small="$vuetify.breakpoint.xsOnly"
                  >mdi-open-in-new</v-icon
                >
              </div>
              <div
                v-if="!$vuetify.breakpoint.xsOnly && itm.all_growth[1]"
                @click="routeToSearchPage(itm.all_growth[1])"
                class="mx-2"
              >
                <span class="brand-name mr-1">{{
                  itm.all_growth[1].symbol
                }}</span>
                <span
                  v-if="itm.all_growth[1].growth != null"
                  class="p-age mr-1"
                  :class="
                    itm.all_growth[1].growth < 0 ? 'red--text' : 'green--text'
                  "
                >
                  {{ itm.all_growth[0].growth >= 0 ? "+" : ""
                  }}{{ itm.all_growth[1].growth }} %
                </span>
                <v-icon small>mdi-open-in-new</v-icon>
              </div>
            </div>
          </v-card-text>
          <!-- <span v-if="itm.all_growth[1]"> for 1 </span> -->
          <div class="endact mt-auto mb-1">
            <v-card-actions class="actions">
              <!-- <div class="card-footer mt-1"> -->
              <div class="source-name">{{ itm.source }}</div>
              <div class="source-time">{{ itm.time }} ago</div>
              <!-- </div> -->
            </v-card-actions>
          </div>
        </div>
      </div>
      <div
        class="py-4"
        v-intersect="onIntersect"
        v-if="page_info.page_number < page_info.total_page"
      >
        <div class="text-center" v-if="intersectLoader">
          <v-progress-circular
            indeterminate
            color="#2f80ed"
          ></v-progress-circular>
          Loading More...
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import Axios from "@/api/BaseAxios.js";
// import ROUTER_URL from "@/constant/urls";

export default {
  data() {
    return {
      intersectLoader: false,
      skeleton_loader: false,
      img: require("@/assets/images/trending/News/news.png"),
      growthList: [],
      newsData: [],
      lazy_img: require("@/assets/images/trending/News/blurImg.png"),
      page_info: {
        detail_count: 10,
        page_number: 1,
        total_page: 1,
      },
    };
  },
  mounted() {
    this.getTradeNews(false);
  },
  methods: {
    onIntersect(entries) {
      // console.log(entries, observer);
      this.intersectLoader = true;
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (this.page_info.page_number < this.page_info.total_page) {
            this.page_info.page_number += 1;
            this.getTradeNews(true);
          } else {
            this.intersectLoader = false;
          }
        }
      });
    },
    getTradeNews(append) {
      const successHandler = (res) => {
        // console.log(res);
        if (append) {
          for (const obj of res.data.news_data) {
            this.newsData.push(obj);
          }
        } else {
          this.skeleton_loader = true;
          this.newsData = res.data.news_data;
          // this.growthList = this.newsData.all_growth;
        }
        this.page_info = res.data.page_info;
        // console.log(this.newsData);
      };
      const failureHandler = () => {};
      // let formData = {};
      // formData["detail_count"] = 5;
      let formData = {};
      formData["detail_count"] = this.page_info.detail_count;
      formData["page_number"] = this.page_info.page_number;
      Axios.request_GET(
        "/api/trade/trending-news",
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },
    routeToSearchPage(item) {
      this.$router.push({
        name: "Search",
        params: { query: `${item.name}-${item.exchange}` },
        query: { tab: 0 },
      });
    },
    // routeToNewDetailPage(item) {
    //   const { id, all_growth } = item;
    //   let query = `${all_growth[0].name}-${all_growth[0].exchange}`;
    //   this.$router.push({
    //     name: ROUTER_URL.userPanel.children.newsDetail.name,
    //     query: { id: id, query: query },
    //   });
    // },

    // forto open direct url
    goToNews(news_url) {
      window.open(news_url);
    },
  },
};
</script>

<style lang="scss" scoped>
.since {
  display: flex;
  justify-content: left;
  flex-direction: row;
  align-items: baseline;
  margin-top: 22px;
}
.red {
  color: rgba(244, 46, 46, 0.838);
}
.green {
  color: #27ae60;
}
.show_more {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 18px;
  color: #2d8cff;
  cursor: pointer;
}
.header {
  color: rgba(0, 0, 0, 0.87);
  font-family: Avenir;
  font-size: 18px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
}
.card-height {
  height: 13.25rem;
}
.card-footer {
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.source-name {
  color: rgba(51, 51, 51, 0.6);
  font-family: Avenir;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 500;
  line-height: 0.875rem; /* 116.667% */
}
.source-time {
  color: rgba(51, 51, 51, 0.6);
  font-family: Avenir;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 500;
  line-height: 0.875rem; /* 116.667% */
}
.actions {
  display: flex;
  justify-content: space-between;
  align-content: center;

  padding-left: 16px;
  padding-right: 16px;
}
.p-age {
  font-family: Avenir;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.brand-name {
  color: #333;
  font-family: Avenir;
  font-size: 0.66rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.since-news {
  color: rgba(51, 51, 51, 0.6);
  font-family: Avenir;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.news-title {
  color: #333;
  font-family: Avenir;
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1rem;
}

.news-subtitle {
  color: rgba(51, 51, 51, 0.6);
  font-family: Avenir;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1rem;
}
.news-subtitle::after {
  content: "see more";
  font-family: "Avenir";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #2d8cff;
  cursor: pointer;
}
.left-arrow {
  transform: rotate(-45deg);
}
.image {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  width: 15rem;
  height: 12.25rem;
}

@media only screen and (max-width: 768px) {
  .image {
    width: 7.875rem !important;
    height: 10rem !important;
  }
  .card-height {
    height: 10rem !important;
  }
  // .news-title {
  //   padding-bottom: px !important;
  // }
  .brand-name {
    font-size: 0.5rem;
    font-weight: 400;
    line-height: normal;
  }
  .since {
    margin-top: 0;
  }
  .since-news {
    font-size: 0.5rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  .p-age {
    font-size: 0.52rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .actions {
    padding-bottom: 0%;
    // display: block;
  }
  .news-title {
    font-size: 0.88rem;
    font-style: normal;
    font-weight: 500;
    line-height: 0.975rem; /* 116.667% */
  }
  .news-subtitle {
    color: rgba(51, 51, 51, 0.6);
    font-size: 0.6rem;
    font-weight: 500;
    line-height: 1rem;
  }
  .source-name {
    font-size: 0.55rem;
  }
  .source-time {
    font-size: 0.55rem;
  }
}
</style>
